import React, { Component } from 'react'

import FeeList from './feeList'

import request from 'request'

import { format } from 'date-fns'

class InstallFeeList extends Component {
  constructor(props) {
    super(props);

  }

  render() {
    const columnsList = [['日期', 'time'], ['小程序', 'extInfo'], ['安装费用', 'fee']];
    const api = request.api.getInstallFeeList;

    const dataKey = 'installationFee';

    const dataFormatter = data => {
      if (!data[dataKey]) {
        return []
      } else {
        return data[dataKey].map((item, idx) => Object.assign(item, {
          fee: `${item.fee / 100}虎牙币`,
          key: idx,
        }))
      }

    }

    const startTime = format(new Date(), 'yyyy-MM')

    return (
      <div>
        <FeeList columnsList={columnsList} api = {api} dataFormatter = {dataFormatter} startTime = {startTime}></FeeList>
      </div>
    )
  }
}

export default InstallFeeList;
